import { render, staticRenderFns } from "./AuthLink.vue?vue&type=template&id=57971ba3&"
import script from "./AuthLink.vue?vue&type=script&lang=js&"
export * from "./AuthLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports